module.exports = __webpack_public_path__ + "img/v2-cart-bowl.a233059b.svg";